import React, { useState , useEffect} from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Krathigai.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';

import city from '../../../city.json'


import axios from 'axios';



const formatTime = (fullStr, format = '12hr') => {
  if (typeof fullStr !== 'string') return '--';

  // Match time with optional AM/PM
  const match = fullStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);

  if (!match) return fullStr; // If no match, return original string

  let [_, hh, mm, period] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);

  let replacementTime = '';

  if (format === '24hr' || format === '24hr+') {
    // Convert to 24-hour format
    if (period?.toUpperCase() === 'PM' && hours !== 12) hours += 12;
    if (period?.toUpperCase() === 'AM' && hours === 12) hours = 0;

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');

    replacementTime = `${paddedHours}:${paddedMinutes}`;
    if (format === '24hr+') {
      replacementTime += ':00'; // add seconds
    }
  } else {
    // 12-hour format
    let suffix = period;
    if (!suffix) {
      suffix = hours >= 12 ? 'PM' : 'AM';
    }

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }

    replacementTime = `${hours}:${mm} ${suffix.toUpperCase()}`;
  }

  // Replace only the matched time part in the original string
  return fullStr.replace(match[0], replacementTime);
};


const Krathigai = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('kolkata');
  const [timeFormat, setTimeFormat] = useState('12');

  const [krathiList, setKrathiList] = useState([]);
   const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedKrathigai, setSelectedKrathigai] = useState(null);


  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

  const karthigaiTooltips = {
  "Masik Karthigai": "Masik Karthigai is a monthly observance dedicated to Lord Murugan (Kartikeya), celebrated when the Krittika Nakshatra is present. Devotees light lamps and offer prayers, signifying the dispelling of darkness and ignorance."
};



useEffect(() => {
  const fetchKrathiData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/karthigai?year=${year}&location=${encodeURIComponent(location)}`
      );
      
     
      if (response.data && response.data.karthigaiDates) {
        setKrathiList(response.data.karthigaiDates);
      } else {
        setKrathiList([]);
      }
   
 
    } catch (error) {
      console.error("Failed to fetch krathigai data:", error);
      setKrathiList([]);
    }
  };

  fetchKrathiData();
}, [year, location]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });
  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

const handleSelect = (cityName) => {
  setTempLocation(cityName);
  setLocation(cityName);   // 🔥 REQUIRED
  setSuggestions([]);
};



  return (
    <div className="Krathigai-container">
      <InnerNav />
      <div className="Krathigai-content">
        <Zodiac />

        {/* Ekadashi Calendar JSX starts here */}
        <div className="calendar-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Krathigai Dates</h2>
              <div className="current-ekadashi">
                <img src="https://images.moneycontrol.com/static-mcnews/2024/12/20241209091930_1.png?impolicy=website&width=770&height=431" alt="Moon" className="moon-preview" />
                <div>
                  
                  <p>{location}</p>
                </div>
               <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>

              <div className="K-controls">
               <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>
              </div>
            </div>
          </div>

{!selectedKrathigai ? (
  <div className="krathi-list">
    {krathiList.length === 0 && (
      <p>No krathigai data available for selected year/location.</p>
    )}

    {krathiList.map((item, idx) => (
      <div
        className="krathi-item clickable"
        key={idx}
        onClick={() => setSelectedKrathigai(item)}
      >
        <img
          src="https://www.astroved.com/astropedia/assets/images/festivals/karthigaidepam.jpg"
          alt={item.title}
        />

        <div className="krathi-details">
          <p className="krathi-date">{item.date}</p>

          <div className="krathi-name">{item.title}</div>

          <p className="krathi-phase">{item.nakshatra}</p>
          <p className="krathi-tithi">{item.tithiName}</p>
          <p className="krathi-tithi">{item.duration}</p>
        </div>

        <div className="krathi-timings">
          <p>{item.lunarDetail}</p>
          <p>{formatTime(item.nakshatraStart, timeFormat)}</p>
          <p>{formatTime(item.nakshatraEnd, timeFormat)}</p>
        </div>
      </div>
    ))}
  </div>
) : (
  <div className="krathigai-detail-view">
    <button className="back-btn" onClick={() => setSelectedKrathigai(null)}>
      ← Back
    </button>

    <h2 className="detail-title">{selectedKrathigai.title}</h2>

    <img
      className="detail-image"
      src="https://www.astroved.com/astropedia/assets/images/festivals/karthigaidepam.jpg"
      alt={selectedKrathigai.title}
    />

    {/* EVENT DETAILS */}
    <div className="detail-section">
      <h3>📅 Event Details</h3>
      <p><strong>Date:</strong> {selectedKrathigai.date}</p>
      <p><strong>Nakshatra:</strong> {selectedKrathigai.nakshatra}</p>
      <p><strong>Tithi:</strong> {selectedKrathigai.tithiName}</p>
      <p><strong>Duration:</strong> {selectedKrathigai.duration}</p>
    </div>

    {/* NAKSHATRA TIMINGS */}
    <div className="detail-section">
      <h3>⏰ Nakshatra Timings</h3>
      <p><strong>Starts:</strong> {formatTime(selectedKrathigai.nakshatraStart, timeFormat)}</p>
      <p><strong>Ends:</strong> {formatTime(selectedKrathigai.nakshatraEnd, timeFormat)}</p>
    </div>

    {/* LUNAR DETAILS */}
    {/* <div className="detail-section">
      <h3>🌙 Lunar Information</h3>
      <p>{selectedKrathigai.lunarDetail}</p>
    </div> */}

    {/* SIGNIFICANCE */}
    <div className="detail-section">
      <h3>🪔 Significance</h3>
      <p>
        {karthigaiTooltips[selectedKrathigai.title] ||
          "Karthigai Nakshatra is dedicated to Lord Murugan and signifies the victory of light over darkness. Lighting lamps on this day is believed to remove negativity and bring divine blessings."}
      </p>
    </div>
  </div>
)
}

        </div>
        {/* Ekadashi Calendar JSX ends here */}

          <section className="karthigai-wrapper">
      <h1 className="karthigai-title">Karthigai Nakshatra Dates</h1>
      <div className="karthigai-texts">
        <p>
          Karthigai Deepam is mainly celebrated by Tamil Hindus. It is one of the oldest festivals celebrated by Tamil people. Houses and streets are lit up with rows of oil lamps or Deepam in the evening of the festival day.
        </p>
        <p>
          Karthigai Deepam and Karthikai Deepam are used interchangeably. Karthigai Deepam takes its name from Nakshatra Karthikai or Krittika. Karthigai Deepam is performed on the day when Krittika Nakshatra is prevailing. Karthigai Deepam is done in honor of Lord Shiva. According to Hindu Mythology on this day Lord Shiva converted himself in an endless flame of light to prove his supremacy to Lord Vishnu and Lord Brahma.
        </p>
        <p>
          Although Karthigai day is observed every month, the most significant day falls in the month of Karthikai (which is the same as Solar month Vrischika in other Hindu calendars).
        </p>
        <p>
          Karthigai festival in Tiruvannamalai hills is very famous. On Karthigai day, a huge fire lamp is lit up on the hill, visible for several kilometers around the hill. The fire or Deepam is called Mahadeepam. Hindu devotees visit here and pray to God Shiva.
        </p>
      </div>
    </section>
            <VratLinks/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default Krathigai;
